import React, { createContext } from 'react';

export const NosotrosContext = createContext();